<template lang="pug">
aside.aic-dock(
	v-if="isVisible"
	:class="{ collapsed: isCollapsed }"
)
	button.aic-dock-toggle(
		type="button"
		:title="isCollapsed ? 'Open AI Chat' : 'Close AI Chat'"
		:aria-expanded="isCollapsed ? 'false' : 'true'"
		@click="togglePanel"
	)
		v-icon.aic-dock-icon mdi-creation
	.ai-chat-embed-root.aic-dock-body(v-if="hasOpened" v-show="!isCollapsed")
		AiChatWorkspace(embedded)
</template>
<script>
import AiChatWorkspace from '@/components/aiChat/AiChatWorkspace.vue';
import './ai-chat.sass';

const KIOSK_ROUTE_NAMES = {
	Kiosk: true,
	'Kiosk Branded': true,
	'Kiosk Public': true,
	'Kiosk Demo': true
};

/**
 * Right-edge AI Chat panel for the regular UI. Hidden on the full AI Chat page.
 */
export default {
	name: 'AiChatDock',
	components: { AiChatWorkspace },
	data() {
		return {
			isCollapsed: true,
			hasOpened: false
		};
	},
	computed: {
		/**
		 * True when the current user is an admin or superAdmin.
		 * @returns {boolean}
		 */
		isAdmin() {
			const user = this.$store.state.user;
			if (!user) return false;
			const role = user.role || (user.attributes && user.attributes.role);
			return role === 'admin' || role === 'superAdmin';
		},
		/**
		 * Current project id from the route or Vuex.
		 * @returns {string|null}
		 */
		projectId() {
			return this.$route.params.projectId || (this.$store.state.project && this.$store.state.project.objectId) || null;
		},
		/**
		 * True on public or shared kiosk screens.
		 * @returns {boolean}
		 */
		isKioskRoute() {
			return !!KIOSK_ROUTE_NAMES[this.$route.name];
		},
		/**
		 * Show the dock on main apps for admins, never on the AI Chat page itself.
		 * @returns {boolean}
		 */
		isVisible() {
			if (!this.$store.getters.isLoggedIn) return false;
			if (!this.isAdmin) return false;
			if (!this.projectId) return false;
			if (this.$route.name === 'AiChat') return false;
			if (this.$route.name === 'Library') return false;
			if (this.isKioskRoute) return false;
			if (!this.$store.getters.hasAtriumOrg) return false;
			return true;
		}
	},
	methods: {
		/**
		 * Expand or collapse the right-edge chat panel.
		 */
		togglePanel() {
			this.isCollapsed = !this.isCollapsed;
			if (!this.isCollapsed) this.hasOpened = true;
		}
	}
};
</script>
